import { Dispatch, SetStateAction } from "react";
import CustomLabel from "../../common/CustomLabel";
import { FilterCriteria } from "../../../types";
import CustomAccordion from "../../common/CustomAccordion";

const ReportSupportServicesFilter = ({
  filterCriteria,
  setFilterCriteria,
}: {
  filterCriteria: FilterCriteria;
  setFilterCriteria: Dispatch<SetStateAction<FilterCriteria>>;
}) => {
  const handleServiceChange = (
    field: "NeedAnAttorney" | "NeedCounseling" | "NeedPrivateInvestigator",
    value: boolean | null
  ) => {
    setFilterCriteria((prev) => ({
      ...prev,
      supportServices: {
        ...prev.supportServices,
        [field]: value,
      },
    }));
  };

  return (
    <CustomAccordion label="Support services" defaultOpen={true}>
      <div className="flex flex-col gap-4">
        <CustomLabel
          labelText="Needs Attorney:"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <div className="flex items-center gap-4 px-4 py-2">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedAnAttorney"
                checked={filterCriteria.supportServices.NeedAnAttorney === true}
                onChange={() => handleServiceChange("NeedAnAttorney", true)}
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">Yes</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedAnAttorney"
                checked={
                  filterCriteria.supportServices.NeedAnAttorney === false
                }
                onChange={() => handleServiceChange("NeedAnAttorney", false)}
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">No</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedAnAttorney"
                checked={filterCriteria.supportServices.NeedAnAttorney === null}
                onChange={() => handleServiceChange("NeedAnAttorney", null)}
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">Any</span>
            </label>
          </div>
        </CustomLabel>

        <CustomLabel
          labelText="Needs Counseling:"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <div className="flex items-center gap-4 px-4 py-2">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedCounseling"
                checked={filterCriteria.supportServices.NeedCounseling === true}
                onChange={() => handleServiceChange("NeedCounseling", true)}
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">Yes</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedCounseling"
                checked={
                  filterCriteria.supportServices.NeedCounseling === false
                }
                onChange={() => handleServiceChange("NeedCounseling", false)}
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">No</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedCounseling"
                checked={filterCriteria.supportServices.NeedCounseling === null}
                onChange={() => handleServiceChange("NeedCounseling", null)}
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">Any</span>
            </label>
          </div>
        </CustomLabel>

        <CustomLabel
          labelText="Needs Private Investigator:"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <div className="flex items-center gap-4 px-4 py-2">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedPrivateInvestigator"
                checked={
                  filterCriteria.supportServices.NeedPrivateInvestigator ===
                  true
                }
                onChange={() =>
                  handleServiceChange("NeedPrivateInvestigator", true)
                }
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">Yes</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedPrivateInvestigator"
                checked={
                  filterCriteria.supportServices.NeedPrivateInvestigator ===
                  false
                }
                onChange={() =>
                  handleServiceChange("NeedPrivateInvestigator", false)
                }
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">No</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="NeedPrivateInvestigator"
                checked={
                  filterCriteria.supportServices.NeedPrivateInvestigator ===
                  null
                }
                onChange={() =>
                  handleServiceChange("NeedPrivateInvestigator", null)
                }
                className="form-radio"
              />
              <span className="font-medium text-[14px] text-black">Any</span>
            </label>
          </div>
        </CustomLabel>
      </div>
    </CustomAccordion>
  );
};

export default ReportSupportServicesFilter;
